import { useState } from 'react';
import type { ProjectSearchResult } from '@/api/planning';
import type { AddSectionLine } from '@/api/onderaannemersPoEdit';
import { AddLineModalShell } from './AddLineModalShell';
import { ProjectPicker } from './ProjectPicker';

interface AddSectionModalProps {
  onAdd: (payload: AddSectionLine) => Promise<void>;
  onClose: () => void;
}

/** Add a `══ dag · werf (S-nr) ══` section header for a project. */
export function AddSectionModal({ onAdd, onClose }: AddSectionModalProps) {
  const [project, setProject] = useState<ProjectSearchResult | null>(null);
  const [date, setDate] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!project || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await onAdd({ kind: 'section', projectId: project.id, date: date || null });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sectie toevoegen mislukt');
      setSubmitting(false);
    }
  };

  return (
    <AddLineModalShell
      title="Sectie toevoegen"
      submitLabel="Toevoegen"
      submitting={submitting}
      canSubmit={!!project}
      error={error}
      onSubmit={handleSubmit}
      onClose={onClose}
    >
      <div>
        <label className="block text-sm font-semibold text-td-navy mb-1">Project</label>
        <ProjectPicker selected={project} onSelect={setProject} autoFocus />
      </div>
      <div>
        <label htmlFor="add-section-date" className="block text-sm font-semibold text-td-navy mb-1">
          Datum <span className="font-normal text-td-muted">(optioneel)</span>
        </label>
        <input
          id="add-section-date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-td-navy focus:outline-none focus:ring-2 focus:ring-td-blue"
        />
      </div>
    </AddLineModalShell>
  );
}
